"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularMessage = exports.TabMessage = exports.OffscreenMessage = exports.MessageTarget = void 0;
/**
 * Application-specific message type constant enum.
 * Keep it all together to avoid, using same key with different purposes.
 * Same consistent keys should be used inside global types declarations.
 */
var MessageTarget;
(function (MessageTarget) {
    MessageTarget["OFFSCREEN"] = "offscreen";
    MessageTarget["REGULAR"] = "regular";
    MessageTarget["SIDEBAR"] = "sidebar";
    MessageTarget["SCHEDULER_DIALOG"] = "scheduler-dialog";
})(MessageTarget = exports.MessageTarget || (exports.MessageTarget = {}));
var OffscreenMessage;
(function (OffscreenMessage) {
    OffscreenMessage["SERVER_PROXY_METHOD_FORWARD"] = "SERVER_PROXY_METHOD_FORWARD";
    OffscreenMessage["SERVER_GET_AUTHORIZATION_REQUEST"] = "SERVER_GET_AUTHORIZATION_REQUEST";
})(OffscreenMessage = exports.OffscreenMessage || (exports.OffscreenMessage = {}));
var TabMessage;
(function (TabMessage) {
    TabMessage["SCRIPT_EXECUTED_CHECK"] = "SCRIPT_EXECUTED_CHECK";
    TabMessage["SCHEDULER_INSERT_SPOTS"] = "SCHEDULER_INSERT_SPOTS";
    TabMessage["SCHEDULER_COPY_LINK"] = "SCHEDULER_COPY_LINK";
    TabMessage["SCHEDULER_INSERT_GUESTS_AND_SUBJECT"] = "SCHEDULER_INSERT_GUESTS_AND_SUBJECT";
    TabMessage["SCHEDULER_DIALOG_CLOSE"] = "SCHEDULER_DIALOG_CLOSE";
})(TabMessage = exports.TabMessage || (exports.TabMessage = {}));
var RegularMessage;
(function (RegularMessage) {
    RegularMessage["SCHEDULER_DIALOG_OPEN_REQUEST"] = "SCHEDULER_DIALOG_OPEN_REQUEST";
    RegularMessage["SCHEDULER_DIALOG_OPEN"] = "SCHEDULER_DIALOG_OPEN";
    RegularMessage["SCHEDULER_DIALOG_CLOSE"] = "SCHEDULER_DIALOG_CLOSE";
    RegularMessage["SCHEDULER_LOGOUT"] = "SCHEDULER_LOGOUT";
    RegularMessage["SET_IS_AUTHORIZED"] = "SET_IS_AUTHORIZED";
    RegularMessage["SET_STORAGE"] = "SET_STORAGE";
    RegularMessage["GET_STORAGE"] = "GET_STORAGE";
    RegularMessage["IFRAME_AUTH_READY"] = "IFRAME_AUTH_READY";
    RegularMessage["INIT_AUTH_STORAGE"] = "INIT_AUTH_STORAGE";
    RegularMessage["DIALOG_AUTH_READY"] = "DIALOG_AUTH_READY";
    RegularMessage["GET_OUTLOOK_RECIPIENTS"] = "GET_OUTLOOK_RECIPIENTS";
    RegularMessage["SCHEDULER_INSERT_SPOTS"] = "SCHEDULER_INSERT_SPOTS";
    RegularMessage["SCHEDULER_COPY_LINK"] = "SCHEDULER_COPY_LINK";
    RegularMessage["SCHEDULER_INSERT_GUESTS_AND_SUBJECT"] = "SCHEDULER_INSERT_GUESTS_AND_SUBJECT";
    RegularMessage["SCHEDULER_REMOVE_TRIGGER_BUTTON"] = "SCHEDULER_REMOVE_TRIGGER_BUTTON";
    RegularMessage["SERVER_PROXY_METHOD_REQUEST"] = "SERVER_PROXY_METHOD_REQUEST";
    RegularMessage["SERVER_PROXY_METHOD_RESPONSE"] = "SERVER_PROXY_METHOD_RESPONSE";
    RegularMessage["SERVER_GET_AUTHORIZATION_RESPONSE"] = "SERVER_GET_AUTHORIZATION_RESPONSE";
    RegularMessage["TOGGLE_ACTIVE_TAB_SIDEBAR"] = "TOGGLE_ACTIVE_TAB_SIDEBAR";
    RegularMessage["SALESFORCE_AUTHORIZATION_CHECK"] = "SALESFORCE_AUTHORIZATION_CHECK";
    RegularMessage["SALESFORCE_AUTHORIZATION_PERFORM"] = "SALESFORCE_AUTHORIZATION_PERFORM";
    RegularMessage["SALESFORCE_AUTHORIZATION_STATE"] = "SALESFORCE_AUTHORIZATION_STATE";
    RegularMessage["GMAIL_NEW_MESSAGE_SLOTS_HTML_INSERT"] = "GMAIL_NEW_MESSAGE_SLOTS_HTML_INSERT";
    RegularMessage["INJECT_INBOXSDK"] = "inboxsdk__injectPageWorld";
})(RegularMessage = exports.RegularMessage || (exports.RegularMessage = {}));
